export const appInsightsConfig = {
    instrumentationKey: process.env.VUE_APP_APPINS_INSTRUMENTATION_KEY,
    loggingLevelConsole: process.env.VUE_APP_APPINS_CONSOLE_LOGLEVEL,
    // Track route changes in SPA's
    enableAutoRouteTracking: true
};